import React from "react";
import PropTypes from "prop-types"
import { Button, Modal } from "react-bootstrap";
import Client from "../Client";
import ContactList from "./ContactList";
import ContactForm from "../forms/ContactForm";

class ContactManager extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      show: false,
      contacts: []
    };
  }

  componentDidMount() {
    Client.getLocationContacts(this.props.locationId).then(contacts => {
      this.setState({ contacts });
    });
  }

  handleClose() {
    this.setState({ contacts: [], show: false });
  }

  handleShow() {
    this.setState({ show: true });
    Client.getLocationContacts(this.props.locationId).then(contacts => {
      this.setState({ contacts });
    });
  }

  handleSubmit(attributes) {
    return Client.createLocationContact(this.props.locationId, attributes)
      .then(contact => {
        this.setState(prevState => ({
          contacts: prevState.contacts.concat(contact)
        }));
      })
  }

  render() {
    return (
      <div style={{marginTop: 5}}>
        <Button bsStyle="primary" bsSize="small" onClick={this.handleShow}>
          Manage Contacts
        </Button>

        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Manage Location Contacts</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>Existing Contacts</h4>
            <ContactList contacts={this.state.contacts} />
            <ContactForm onSubmit={this.handleSubmit}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleClose}>Close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
ContactManager.propTypes = {
  locationId: PropTypes.number.isRequired
}

export default ContactManager;



// WEBPACK FOOTER //
// ./src/dev/ContactManager.js